import React ,{Component} from "react"
import axios  from "axios";
import { 
  Autocomplete, 
  TableCell, 
  TableRow, 
  TextField, 
  Button, 
  IconButton, 
  FormControl, 
  Collapse, 
  Alert 
} from "@mui/material";
import {NavLink, Navigate  } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
export default class Aboutyourbusiness  extends React.Component{

  	constructor(props) {
    super();
    this.state={
      Businessname:'',address1:'',address2:'',state:'',zipcode:'',  countrydata:[],coid:'',submitbtn:'Save',erropen:false,errormessage:'',
      

    }
}

componentWillMount() {
	
  
 if(localStorage.getItem("ISIuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {
			  this.GetCompantData();

this.countrybind();
		  }
		  else{
	    
		this.PageAccessCheckApi();
		  }
	}
 this.props.parentdasCallback(
            "About your business~"
        );


	}


PageAccessCheckApi() {
	
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=17')
  
  .then(resp => {
	  
	  
	  let strreturn=resp.data;

      if (strreturn!==0) {
        	
   this.GetCompantData();

this.countrybind();
      } else {
       
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
    
  });
}
handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  }


GetCompantData = () => {

 
axios.get(localStorage.getItem("ISIurl")+'ajaxcompany.php?action=getall&cmp_id='+localStorage.getItem("ISIcmpid"))
.then(resp =>{

    this.setState({

      Businessname:resp.data[0]["cmp_name"],
       address1:resp.data[0]["cmp_address1"],
        address2:resp.data[0]["cmp_address2"],
         city:resp.data[0]["cmp_city"],
          state:resp.data[0]["cmp_state"],
           zipcode:resp.data[0]["cmp_pincode"],
            coid:resp.data[0]["cmp_co_id"],

    });

});




}



 onclickCancel = (e) => {
	this.setState({redirect:true,pagename:'/settings'});
 }




countrybind(){

    axios.get(localStorage.getItem("ISIurl")+'ajaxcountry.php?action=getall')
  
    
      .then((resp) => {    
     

    
    
    let CountryApi = resp.data.map(row => {
                      
          return {value: row.co_id, display:row.co_name}
        });
    
     this.setState({
          countrydata: [{value: '', display:'Select Country'}].concat(CountryApi)
        },()=>{console.log(this.state.countrydata)});
      }).then(data => {
     
        
      
    
       
      })


   
    
}


myChangeHandler = (event) => {
    let nam = event.target.name;
    let val =  event.target.value;

   
    this.setState({[nam]: val},()=>{});
    
   

}




  onClickSalesSave= (event) => {
	
    event.preventDefault();

      if(this.state.Businessname==="")
  {
    this.setState({errormessage:"Please enter business name",erropen:true,errorstatus:'error'});
    return false;
  }


       if(this.state.address1==="")
  {
    this.setState({errormessage:"Please enter address",erropen:true,errorstatus:'error'});
    return false;
  }


       if(this.state.city==="")
  {
    this.setState({errormessage:"Please enter city",erropen:true,errorstatus:'error'});
    return false;
  }


       if(this.state.state==="")
  {
    this.setState({errormessage:"Please enter state",erropen:true,errorstatus:'error'});
    return false;
  }


       if(this.state.zipcode==="")
  {
    this.setState({errormessage:"Please enter zipcode",erropen:true,errorstatus:'error'});
    return false;
  }
this.setState({btndisabled:true,submitbtn:"Processing...",errormessage:'',erropen:false})

var formData = new FormData();

	 formData.append('action','insertorupdate')
formData.append('cmp_id',localStorage.getItem('ISIcmpid'))
formData.append('cmp_name',this.state.Businessname)
formData.append('cmp_address1',this.state.address1)
formData.append('cmp_address2',this.state.address2)
formData.append('cmp_city',this.state.city)
formData.append('cmp_state',this.state.state)
formData.append('cmp_pincode',this.state.zipcode)
formData.append('cmp_co_id',this.state.coid)
formData.append('cmp_website','')
formData.append('cmp_phone','')
formData.append('cmp_email','')

formData.append('userid',localStorage.getItem('ISIuserid'))
axios.post(localStorage.getItem("ISIurl")+"ajaxcompany.php", formData, {
        }).then(res => {
							if(res.data !="")
{ 
		this.setState({errormessage:"Updated Successfully.",erropen:true,open:true,btndisabled:false,errorstatus:'success',
submitbtn:"Submit",
		});
		window.scrollTo({
          top: 0
      })
		 return false;

	}
	});    
  };


render() {


  if(this.state.redirect===true){
     return <Navigate to={this.state.pagename} />
  }
	
return (

  <React.Fragment>
    <div className="whitebg">
        <div className="formmain">


  <p><Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
            <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.errorstatus}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>


          <div className="businesssetting">
              <div className="aboutbusleftpagetitle">
                <h5>BUSINESS NAME AND TRADING ADDRESS</h5>
                <p>Where do you run your business from day-to-day?</p>
                <p>Changes will be reflected accross all Sage applications.</p>

              </div>

              <div className="aboutbuspagecontentright">

               <table>
                <TableRow>

                  <TableCell>Business name <span className="validation">*</span></TableCell>
                  <TableCell> <TextField className="txtbox" name="Businessname" value={this.state.Businessname}  onChange={this.myChangeHandler} disabled = {this.state.btndisabled}/></TableCell>

                </TableRow>

                <TableRow>

                  <TableCell>Address 1 <span className="validation">*</span></TableCell>
                  <TableCell> <TextField className="txtbox" name="address1" value={this.state.address1}  onChange={this.myChangeHandler}  disabled = {this.state.btndisabled} /></TableCell>

                </TableRow>


                <TableRow>

                  <TableCell>Address 2 </TableCell>
                  <TableCell> <TextField className="txtbox" name="address2" value={this.state.address2}  onChange={this.myChangeHandler}  disabled = {this.state.btndisabled}/></TableCell>

                </TableRow>


                <TableRow>

                  <TableCell>City/Town <span className="validation">*</span></TableCell>
                  <TableCell> <TextField className="txtbox" name="city" value={this.state.city}  onChange={this.myChangeHandler}  disabled = {this.state.btndisabled} /></TableCell>

                </TableRow>

                <TableRow>

                  <TableCell>State <span className="validation">*</span></TableCell>
                  <TableCell> <TextField className="txtbox" name="state" value={this.state.state}  onChange={this.myChangeHandler}  disabled = {this.state.btndisabled} /></TableCell>

                </TableRow>


                 <TableRow>

                  <TableCell>Zip Code <span className="validation">*</span></TableCell>
                  <TableCell> <TextField className="txtbox" name="zipcode" value={this.state.zipcode}  onChange={this.myChangeHandler}  disabled = {this.state.btndisabled} /></TableCell>

                </TableRow>

                <TableRow>




                  <TableCell>Country </TableCell>
                   <TableCell>
                        <FormControl className="businessdrp">
        <select native fullWidth margin="normal" defaultValue={{label:this.state.coid,value:this.state.coid}}
className="txtbox"
        onChange={this.myChangeHandler} id="coid" value={this.state.coid} name="coid" 

        > {this.state.countrydata.map(con => (
        <option value={con.value} >
        {con.display}

        </option>


          ))}</select>

                 </FormControl></TableCell>


                  

                </TableRow>


               </table>
</div>



          </div>

          <div className="clear"></div>
<p style={{textAlign:'right'}}>
            <Button variant="contained" disabled= {this.state.btndisabled} className="frmSecondarybtn" onClick={this.onClickSalesSave}>
                 {this.state.submitbtn}
            </Button>&nbsp;
                <Button variant="contained" className="frmthirdbtn" onClick={this.onclickCancel}>
                Cancel
            </Button>
            </p>

        </div>
    </div>
  </React.Fragment>
  
);

}



}






